// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0vw;
  width: 100%;
  padding: 0vw;
  margin: 0vw;
  background: transparent;
  align-items: center;
  border-radius: 0px;
  border: 0px solid var(--ion-color-tertiary);
  transition: all 0.5s ease-in-out;
  z-index: 999;
  color: var(--ion-text-secondary);
  z-index: 19;
  overflow: visible;
  max-height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
}

.signUpComponent {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0vw;
  padding: 0vw;
  margin: 0vw;
  width: 100%;
  background: transparent;
  align-items: center;
  border-radius: 0px;
  border: 0px solid var(--ion-color-tertiary);
  transition: all 0.5s ease-in-out;
  color: var(--ion-text-secondary);
  z-index: 19;
  overflow: visible;
  max-height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
}

.fieldset {
  border: 1px var(--ion-color-black) solid;
  font-size: 12px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0vh;
  padding: 0.25vh 0 0vh 0.5vh;
  width: 100%;
  max-height: 6vh;
  min-height: 6vh;
  font-weight: 400;
  pointer-events: all;
  text-transform: capitalize;
  letter-spacing: 2px;
  color: var(--ion-color-black);
  margin: 3vw 0 0 0vh;
  --color: var(--ion-color-black);
  margin-inline: 0;
  transition: all 0.3s ease-in-out;
}
.fieldset .legend {
  color: var(--ion-color-black);
  text-transform: capitalize;
  font-weight: 500;
  font-size: 10px;
  padding: 0vh 1vh;
  letter-spacing: 1px;
}
.fieldset .eye-pwd,
.fieldset .bioicon {
  stroke: var(--ion-color-primary);
  padding: 0vw 0.5vh 0.5vh;
  height: 6vw;
  min-width: 6vw;
  fill: none;
  transition: all 0.5s ease-in-out;
  stroke-width: 1.5px;
  cursor: pointer;
}
.fieldset .eye-pwd {
  stroke: var(--ion-dark-danger);
}
.fieldset ion-input,
.fieldset .app-input {
  outline: none;
  border: none;
  background: transparent;
  padding: 0 2vw !important;
  font-size: 12px;
  border-radius: 0px;
  box-shadow: none;
  margin: 0;
  height: 3vh;
  --color: var(--ion-color-black);
  width: 100%;
}
.fieldset input.app-input {
  color: var(--ion-color-black);
}

.withoutM {
  margin: 0;
}

.stagBar {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;
  gap: 3vw;
}

.passForget {
  stroke: var(--ion-color-danger);
  padding: 0;
  margin: 1vh 0;
  height: 3vh;
  width: 3vh;
  fill: none;
  border-radius: 8px;
  transition: all 0.5s ease-in-out;
  stroke-width: 1px;
  cursor: pointer;
  border: 1px var(--ion-half-danger) dotted;
  box-sizing: content-box;
}

.hidden-input {
  display: none;
}

.termsBox {
  margin: 1vh 0;
  display: flex;
  align-items: center;
  gap: 1vh;
  font-size: 12px;
  color: var(--ion-darker-primary);
}

.termsLink {
  color: var(--ion-color-info);
  -webkit-text-decoration: underline 1px solid var(--ion-color-info);
          text-decoration: underline 1px solid var(--ion-color-info);
  cursor: pointer;
}

.fname,
.lname {
  width: 100%;
}
.smallName {
  width: 75%;
}
.smallName .app-input {
  width: 100%;
}

.disabledInput {
  pointer-events: none;
  font-size: 10px;
}

.btnBar {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  transition: all 0.3s ease-in-out;
  padding: 0;
  margin: 3vw 0% 0vh 0%;
  gap: 3vw;
}

.btnSmall .btnIconInner {
  stroke: var(--ion-text-secondary);
  height: 4vh;
  width: 4vh;
}

.popLoadingBack {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  /* Slightly darker for better contrast */
  display: flex;
  align-items: flex-end;
  /* Align to the bottom like an Ionic modal */
  justify-content: center;
  z-index: 1000;
  /* Simple fade-in animation for the backdrop */
  animation: fadeIn 0.3s ease-out;
  backdrop-filter: blur(5px);
}

.popLoading {
  background: rgba(255, 255, 255, 0);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  height: 100%;
  /* Prevents the modal from taking up the entire screen */
  /* Slide-up animation from the bottom */
  animation: slideInUp 0.4s ease-out;
}

.popLoader {
  padding: 5vh;
  flex-grow: 1;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideInUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0vh);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/signup-form/signup.component.scss"],"names":[],"mappings":"AAYA;EACE,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EAEA,gCAAA;EAIA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,iBAAA;EACA,iFAAA;AAhBF;;AAkBA;EACC,kBAAA;EACG,aAAA;EAEA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;EACA,iBAAA;EACA,iFAAA;AAhBJ;;AAkBA;EACE,wCAAA;EAEA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,gCAAA;AAhBF;AAkBE;EACE,6BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBJ;AAmBE;;EAEE,gCAAA;EACA,wBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,8BAAA;AAlBJ;AAqBE;;EAEE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,WAAA;AAnBJ;AAuBE;EACE,6BAAA;AArBJ;;AAyBA;EACE,SAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,WAAA;EACA,QAAA;AAtBF;;AAyBA;EACI,+BAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;EACA,uBAAA;AAtBJ;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;AAtBF;;AAyBA;EACE,4BAAA;EACA,kEAAA;UAAA,0DAAA;EACA,eAAA;AAtBF;;AAyBA;;EAEE,WAAA;AAtBF;AA+BA;EAEE,UAAA;AA9BF;AAgCE;EACE,WAAA;AA9BJ;;AAmCA;EACE,oBAAA;EACA,eAAA;AAhCF;;AAkCA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,UAAA;EACA,qBAAA;EACA,QAAA;AA/BF;;AAmCC;EACC,iCAAA;EACA,WAAA;EACA,UAAA;AAhCF;;AAsCA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,wCAAA;EACA,aAAA;EACA,qBAAA;EACA,4CAAA;EACA,uBAAA;EACA,aAAA;EACA,8CAAA;EACA,+BAAA;EACA,0BAAA;AAnCJ;;AAsCA;EACI,kCAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,wDAAA;EACA,uCAAA;EACA,kCAAA;AAnCJ;;AAsCA;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAnCJ;;AAuCA;EACI;IACI,UAAA;EApCN;EAuCE;IACI,UAAA;EArCN;AACF;AAwCA;EACI;IACI,2BAAA;EAtCN;EAyCE;IACI,0BAAA;EAvCN;AACF","sourcesContent":["// :host {\n// \tdisplay: flex;\n// \theight: 100%;\n// \tbackground: transparent;\n// \tz-index: 1;\n// \tposition: relative;\n// \twidth: 100vw;\n// \tposition: relative;\n// \tmargin: 0 auto;\n\n// }\n\n:host {\n  position: relative;\n//   bottom: calc(5vh + env(safe-area-inset-bottom));\n  display: flex;\n  flex-direction: column;\n  gap: 0vw;\n  width: 100%;\n  padding: 0vw;\n  margin: 0vw;\n  background: transparent;\n  align-items: center;\n  border-radius: 0px;\n  border: 0px solid var(--ion-color-tertiary);\n//   box-shadow: var(--shadow-btn-anim);\n  transition: all 0.5s ease-in-out;\n//   backdrop-filter: blur(10px) !important;\n//   background: hsl(var(--drop-white-primary)/0);\n//   border: 1px solid rgba(255, 255, 255, 0.45);\n  z-index: 999;\n  color: var(--ion-text-secondary);\n  z-index: 19;\n  overflow: visible;\n  max-height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom)); // Max height for signup\n}\n.signUpComponent {\n position: relative;\n    display: flex\n;\n    flex-direction: column;\n    gap: 0vw;\n    padding: 0vw;\n    margin: 0vw;\n    width: 100%;\n    background: transparent;\n    align-items: center;\n    border-radius: 0px;\n    border: 0px solid var(--ion-color-tertiary);\n    transition: all 0.5s ease-in-out;\n    color: var(--ion-text-secondary);\n    z-index: 19;\n    overflow: visible;\n    max-height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n}\n.fieldset {\n  border: 1px var(--ion-color-black) solid;\n//   filter: drop-shadow(1px 1px 1px var(--ion-ultra-primary));\n  font-size: 12px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0vh;\n  padding: 0.25vh 0 0vh 0.5vh;\n  width: 100%;\n  max-height: 6vh;\n  min-height: 6vh;\n  font-weight: 400;\n  pointer-events: all;\n  text-transform: capitalize;\n  letter-spacing: 2px;\n  color: var(--ion-color-black);\n  margin: 3vw 0 0 0vh;\n  --color: var(--ion-color-black);\n  margin-inline: 0;\n  transition: all 0.3s ease-in-out; // Consistent transition for fieldsets\n\n  .legend {\n    color: var(--ion-color-black);\n    text-transform: capitalize;\n    font-weight: 500;\n    font-size: 10px;\n    padding: 0vh 1vh;\n    letter-spacing: 1px;\n  }\n\n  .eye-pwd,\n  .bioicon {\n    stroke: var(--ion-color-primary); // Default stroke for icons\n    padding: 0vw 0.5vh 0.5vh; // Adjusted padding\n    height: 6vw;\n    min-width: 6vw;\n    fill: none;\n    transition: all 0.5s ease-in-out;\n    stroke-width: 1.5px;\n    cursor: pointer; // Indicate clickable\n  }\n\n  .eye-pwd {\n    stroke: var(--ion-dark-danger); // Specific stroke for password eye\n  }\n\n  ion-input,\n  .app-input {\n    outline: none;\n    border: none;\n    background: transparent;\n    padding: 0 2vw !important;\n    font-size: 12px;\n    border-radius: 0px;\n    box-shadow: none;\n    margin: 0;\n    height: calc(3vh); // Adjusted height\n    --color: var(--ion-color-black);\n    width: 100%; // Fill available width\n  }\n\n  // If you want native inputs to also have the Ionic --color\n  input.app-input {\n    color: var(--ion-color-black);\n  }\n}\n\n.withoutM {\n  margin: 0;\n}\n\n.stagBar {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: flex-start;\n  width: 100%;\n  gap: 3vw;\n}\n\n.passForget {\n    stroke: var(--ion-color-danger);\n    padding: 0;\n    margin: 1vh 0;\n    height: 3vh;\n    width: 3vh;\n    fill: none;\n    border-radius: 8px;\n    transition: all 0.5s ease-in-out;\n    stroke-width: 1px;\n    cursor: pointer;\n    border: 1px var(--ion-half-danger) dotted;\n    box-sizing: content-box;\n}\n\n.hidden-input {\n  display: none;\n}\n\n.termsBox {\n  margin: 1vh 0;\n  display: flex;\n  align-items: center;\n  gap: 1vh;\n  font-size: 12px;\n  color: var(--ion-darker-primary);\n}\n\n.termsLink {\n  color: var(--ion-color-info);\n  text-decoration: underline 1px solid var(--ion-color-info);\n  cursor: pointer; // Indicate clickable\n}\n\n.fname,\n.lname {\n  width: 100%;\n\n  // Specific adjustments for these fieldsets\n  &.nameSelected {\n    // This class should be applied when one of them is selected\n    // It indicates that the current input is the \"main\" one\n  }\n}\n\n.smallName {\n  // This class should apply to the *other* name fieldset when one is active\n  width: 75%; // Make the \"other\" name field smaller\n\n  .app-input {\n    width: 100%; // Input inside should fill its parent\n  }\n}\n\n\n.disabledInput {\n  pointer-events: none; // Prevent interaction\n  font-size: 10px; // Smaller font size\n}\n.btnBar {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  transition: all 0.3s ease-in-out;\n  padding: 0;\n  margin: 3vw 0% 0vh 0%;\n  gap: 3vw;\n}\n\n.btnSmall{\n\t.btnIconInner{\n\t\tstroke: var(--ion-text-secondary);\n\t\theight: 4vh;\n\t\twidth: 4vh;\n\t}\n}\n\n\n\n.popLoadingBack {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    /* Slightly darker for better contrast */\n    display: flex;\n    align-items: flex-end;\n    /* Align to the bottom like an Ionic modal */\n    justify-content: center;\n    z-index: 1000;\n    /* Simple fade-in animation for the backdrop */\n    animation: fadeIn 0.3s ease-out;\n    backdrop-filter: blur(5px);\n}\n\n.popLoading {\n    background: #fff0;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    width: 100%;\n    max-width: 500px;\n    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.15);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    /* Prevents the modal from taking up the entire screen */\n    /* Slide-up animation from the bottom */\n    animation: slideInUp 0.4s ease-out;\n}\n\n.popLoader {\n    padding: 5vh;\n    flex-grow: 1;\n    display: flex;\n    overflow-y: auto;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideInUp {\n    from {\n        transform: translateY(100%);\n    }\n\n    to {\n        transform: translateY(0vh);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
